export default function AppProgress() {
	return <div className="app-progress"></div>;
}
